// import { InputProps } from "@mui/material";
import React from "react";

const ProfileName = (name: string, secondLetter: boolean) => {
  const letters = name.split(" ");
  if (letters.length > 0) {
    const firstLetter = (letters[0]?.[0] || "").toUpperCase();
    const secondletter =
      letters.length > 2 && letters[2]?.[0]
        ? letters[2][0].toUpperCase()
        : letters.length > 1 && letters[1]?.[0]
          ? letters[1][0].toUpperCase()
          : "";
    if (secondLetter) {
      return `${firstLetter}${secondletter}`;
    }
    return `${firstLetter}`;
  }
};

type InputProps = {
  name?: string;
  className?: string;
  secondLetter?: boolean;
  styles?: any;
  spanStyles?: any;
  color?: any;
};

export function ProfileIcon({
  name = "",
  className = "header-profile-user",
  secondLetter = false,
  styles,
  spanStyles,
  color = null,
}: InputProps) {
  return (
    <>
      {name && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: color ? color : "var(--vc-violet)",
            ...styles,
          }}
          className={` ${className} `}
        >
          <span
            style={{
              ...spanStyles,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {ProfileName(name, secondLetter)}
          </span>
        </div>
      )}
    </>
  );
}
